(function() {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketPaymentDeleteController',TicketPaymentDeleteController);

    TicketPaymentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketPayment'];

    function TicketPaymentDeleteController($uibModalInstance, entity, TicketPayment) {
        var vm = this;

        vm.ticketPayment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketPayment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
